module.exports = "https://portperrypedals.ca/_res/img/wd_40.e6a4d70.png";